import classNames from 'classnames';
import React, { useEffect } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { useFileInput } from 'shared/helpers/hooks';
import Label from './Label';

type ImageInputProps = WrappedFieldProps & {
  id: string;
  type: string;
};

const ImageInput = ({
  input: { name, onChange, value },
  id,
  type,
  ...restProps
}: ImageInputProps) => {
  const { fileUrl, setFileUrl, handleFileInputChange } = useFileInput(value);
  useEffect(() => {
    if (fileUrl !== value) {
      if (fileUrl) {
        onChange(fileUrl);
      } else if (value) setFileUrl(value);
    }
  }, [fileUrl, setFileUrl, value, onChange]);
  return (
    <Label id={id || name} {...restProps}>
      <label
        htmlFor={id || name}
        className={classNames('flex items-center w-full relative', {
          'h-20': type === 'avatar',
          'h-24': type === 'image'
        })}
      >
        <img
          src={value}
          alt={name}
          className={classNames('object-cover', {
            'w-20 h-20 rounded-full mr-4': type === 'avatar',
            'w-full h-24 rounded': type === 'image'
          })}
        />
        <span
          className={classNames('font-body', {
            'text-gray-800': type === 'avatar',
            'absolute w-full h-24 text-center bg-black opacity-50 text-white':
              type === 'image'
          })}
          style={{ lineHeight: '6rem' }}
        >
          Tap to Change
        </span>
      </label>
      <input
        className="hidden"
        name={name}
        id={id || name}
        type="file"
        accept="image/*"
        onChange={handleFileInputChange}
      />
    </Label>
  );
};

export default ImageInput;
